import type { Order as OrderTypes } from '@luxuryescapes/contract-svc-order'

type ServerAccommodationV2Item = OrderTypes.AccommodationV2Item

const EXTERNAL_STATUSES: Array<App.AccommodationBookingExternalStatus> = [
  'pending',
  'reserved',
  'confirmed',
  'failed',
  'cancelled',
]

/** Unknown statuses read as "no status yet" rather than being shown to the customer verbatim. */
function mapExternalStatus(
  status: string | null | undefined,
): App.AccommodationBookingExternalStatus | undefined {
  return EXTERNAL_STATUSES.find(known => known === status)
}

function mapOccupancy(
  occupancy: ServerAccommodationV2Item['occupancy'],
): App.OrderAccommodationV2Occupancy | undefined {
  if (!occupancy) return undefined

  return {
    adults: occupancy.adults ?? 0,
    children: occupancy.children ?? 0,
    teenagers: occupancy.teenagers ?? 0,
    infants: occupancy.infants ?? 0,
    childrenAges: occupancy.childrenAges ?? [],
  }
}

export default function mapAccommodationV2OrderItem(
  item: ServerAccommodationV2Item,
): App.OrderAccommodationV2Item {
  return {
    id: item.id,
    // Coerced rather than passed through: svc-order only began sending this in HP-2888, and a row
    // without it is a native booking.
    isShadow: !!item.is_shadow,
    status: item.status ?? undefined,
    transactionKey: item.transaction_key,
    bookingId: item.booking_id ?? undefined,
    externalBookingNumber: item.external_booking_number ?? undefined,
    externalStatus: mapExternalStatus(item.external_status),
    propertyId: item.property_id,
    roomId: item.room_id,
    checkIn: item.check_in,
    checkOut: item.check_out,
    nights: item.nights,
    occupancy: mapOccupancy(item.occupancy),
  }
}
